import { render, staticRenderFns } from "./MobileServer.vue?vue&type=template&id=c772b42a&scoped=true&"
import script from "./MobileServer.vue?vue&type=script&lang=js&"
export * from "./MobileServer.vue?vue&type=script&lang=js&"
import style0 from "./MobileServer.vue?vue&type=style&index=0&id=c772b42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c772b42a",
  null
  
)

export default component.exports